var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9L12.8689 9.87857C12.6549 10.0405 12.3548 10.0405 12.1408 9.87857L11 9",
    stroke: "#6638A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7792 6H14.211C14.7058 6.00624 15.1768 6.24126 15.5142 6.65035C15.8516 7.05943 16.026 7.60686 15.9968 8.16514V10.8349C16.026 11.3931 15.8516 11.9406 15.5142 12.3497C15.1768 12.7587 14.7058 12.9938 14.211 13H10.7792C9.71634 13 9 12.0285 9 10.8349V8.16514C9 6.97149 9.71634 6 10.7792 6Z",
    stroke: "#6638A2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0H6.55C5.14219 0 5 0.654297 5 2V23C5 24.3457 5.14219 25 6.55 25H18.45C19.8578 25 20 24.3457 20 23V2C20 0.654297 19.9078 0 18.5 0ZM12.5 23.375C11.5597 23.375 10.8 22.6488 10.8 21.75C10.8 20.8512 11.5597 20.125 12.5 20.125C13.4403 20.125 14.2 20.8512 14.2 21.75C14.2 22.6488 13.4403 23.375 12.5 23.375ZM18.45 17.8906C18.45 18.2258 18.1631 18.5 17.8125 18.5H7.1875C6.83687 18.5 6.55 17.8906 6.55 17.8906V2.04688C6.55 1.71172 6.83687 1.4375 7.1875 1.4375H17.8125C18.1631 1.4375 18.45 1.71172 18.45 2.04688V17.8906Z",
    fill: "#6638A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPhone);
export default __webpack_public_path__ + "static/media/EmailPhone.a3d2fde5bccfd09a13fc7c39b8a0043d.svg";
export { ForwardRef as ReactComponent };